import React, {useRef} from 'react'
import {useParams} from "react-router";
import {makeStyles, Tooltip} from '@material-ui/core';
import PropTypes from 'prop-types';
import ExpansionPanel from 'components/ExpansionPanel';
import ArrowIcon from '@material-ui/icons/KeyboardArrowUp'
import clsx from 'clsx';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';

import RouterPath from "libs/RouterPath";
import {
    getSectionVariant,
    PurchasingGroupStageSections,
    StageSectionNameToSectionParam,
    StageSectionParamToSectionName,
    StageSectionsComponents
} from "../constants/PurchasingGroupStageSections";
import ExpansionPanelTitleAvatar from "components/ExpansionPanelTitleAvatar";
import Typography from "components/Typography";
import {connect} from "react-redux";
import {setConfirmCloseStepper} from "redux/actions";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";


const useStyle = makeStyles(theme => ({
    root: {
        '&:not(:first-child)': {
            // marginTop: theme.spacing(1)
        }
    },
    rotate: {
        transform: 'rotate(180deg)'
    },
    adornmentGrid: {
        '&>*:first-child': {
            flexGrow: 1,
            marginRight: theme.spacing(2)
        }
    },
    titleGrid: {
        '&>*:first-child': {
            flexGrow: 10000,
        }
    }
}))

const rps = RouterPath.purchasingGroup;

function PurchasingGroupStageSection(
    {
        validationSection,
        stateCloseValidator,
        setConfirmCloseStepper
    }) {
    const classes = useStyle();
    const params = useParams();
    const groupId = params.id;
    const stage = params.stage;
    const openedSectionParam = params.section;


    const openedSection = openedSectionParam ? StageSectionParamToSectionName[openedSectionParam] : undefined;
    const expanded = openedSection === validationSection.section;
    const panelRef = useRef();

    const handleClick = id => {
        if (validationSection.status !== DemandValidationSectionStatus.DISABLED) {
            if (stateCloseValidator && stateCloseValidator() === false) {
                setConfirmCloseStepper(() => doHandleClick(id));
                return
            }
            doHandleClick(id)
        }
    }
    const doHandleClick = id => {
        if (openedSection === id) {
            RouterPath.redirectWithoutHistory(RouterPath.createPath(rps.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {id: groupId, stage: stage}))
        } else {
            RouterPath.redirectWithoutHistory(RouterPath.createPath(rps.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR_SECTION, {
                id: groupId, stage: stage,
                section: StageSectionNameToSectionParam[id]
            }))
        }
    }

    const Component = StageSectionsComponents[validationSection.section];
    return (
        <ExpansionPanel
            panelRef={panelRef}
            id={validationSection.section}
            title={<GridBlock alignItems="center">
                <ExpansionPanelTitleAvatar variant={getSectionVariant(validationSection)}/>
                <Typography variant='h6'>
                    {validationSection.name}
                </Typography>
            </GridBlock>}
            classesObj={{titleGrid: classes.titleGrid, root: classes.root}}
            titleAdornment={
                <GridBlock
                    wrap='nowrap'
                    className={classes.adornmentGrid}
                    alignItems='center'
                >
                    <div/>
                    <Tooltip title={expanded ? Tr('collapse') : Tr('expand')} placement='top'>
                        <ArrowIcon
                            className={clsx({
                                [classes.rotate]: !expanded
                            })}
                        />
                    </Tooltip>
                </GridBlock>
            }
            expanded={expanded}
            onChange={() => handleClick(validationSection.section)}
        >
            {expanded &&
                <Component panelRef={panelRef} validationSection={validationSection}/>
            }
        </ExpansionPanel>
    )

}

PurchasingGroupStageSection.propTypes = {
    validationSection: PropTypes.shape({
        editable: PropTypes.bool.isRequired,
        infoMessages: PropTypes.array,
        messages: PropTypes.array,
        name: PropTypes.string.isRequired,
        required: PropTypes.bool.isRequired,
        section: PropTypes.oneOf(Object.keys(PurchasingGroupStageSections)).isRequired,
        status: PropTypes.oneOf(Object.keys(DemandValidationSectionStatus)).isRequired,
        validateAfterSave: PropTypes.bool
    })
}

export default connect((state) => ({
    stateCloseValidator: state.stepper.stateCloseValidator,
}), {
    setConfirmCloseStepper
})(PurchasingGroupStageSection)
